var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaregivingActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_lovely",
    "data-name": "vuesax/bold/lovely",
    transform: "translate(-748 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lovely"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(748 252)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9,0A3.466,3.466,0,0,0,6.23,1.39,3.458,3.458,0,0,0,0,3.48,6.788,6.788,0,0,0,.32,5.54a9.39,9.39,0,0,0,5.52,5.49,1.438,1.438,0,0,0,.77,0,9.361,9.361,0,0,0,5.52-5.49,6.538,6.538,0,0,0,.32-2.06A3.457,3.457,0,0,0,9,0Z",
    transform: "translate(757.8 261.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M18.75,5.24a.348.348,0,0,1-.45.32,4.81,4.81,0,0,0-3.95.74.615.615,0,0,1-.73,0,4.65,4.65,0,0,0-2.76-.9,4.7,4.7,0,0,0-4.68,4.71,9.063,9.063,0,0,0,2.71,6.34c.07.07.01.19-.08.15C6.08,15.67,0,11.81,0,5.24A5.208,5.208,0,0,1,9.38,2.09a5.2,5.2,0,0,1,9.37,3.15Z",
    transform: "translate(750 255.1)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregivingActive);
export default __webpack_public_path__ + "static/media/caregiving_active.a2109bdda68be7ba95d4d68dde8bedab.svg";
export { ForwardRef as ReactComponent };